/**
 * Shared normalization for the dashboard status-note payload consumed by
 * `<StatusNotesIndicator>` (and the PA expanded-row panel). Kept here so the PA
 * (`usePATable`) and intake (`intakeFeedRow`) feeds stay in sync on trimming /
 * blank-row handling. Pure module — no app imports — to avoid circular deps.
 */
/** Drop empty notes, trim operational notes, and return `null` when there's nothing to show. */
export function buildStatusNotesPayload(rows, operationalNotes = null) {
    const notes = (rows || []).filter((r) => !!(r && (r.note || "").trim()));
    const ops = (operationalNotes || "").trim() || null;
    if (notes.length === 0 && !ops)
        return null;
    return { notes, operationalNotes: ops };
}
